import { Store } from 'store/index';

const getPredesignedProductPageSelectors = (store: Store) =>
  store.product.designProduct?.designAbstractProduct.productPageSelectors || [];

export default getPredesignedProductPageSelectors;
